import { render } from "./Imprint.vue?vue&type=template&id=caf5cd78&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import "./Imprint.vue?vue&type=style&index=0&id=caf5cd78&lang=css"
import "./Imprint.vue?vue&type=style&index=1&id=caf5cd78&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf5cd78"]])

export default __exports__